@use './main.scss' as *;

.form {
  @include responsive(null, $md1) {
    height: 100%;
    display: grid;
    grid-template-rows: auto min-content;
  }
}

.formColumnFullWidth {
  @extend .col-xs-12;
}

.formColumnAuto {
  @extend .col-xs-12;
  flex-basis: 0;
}

.formColumnFill {
  @extend .col-xs;
}

.formColumn {
  @extend .col-xs-6;
  @include responsive(null, $md1) {
    flex-basis: 100%;
    max-width: 100%;
  }
}

.formColumn2 {
  @extend .col-xs-2;
  @include responsive(null, $md1) {
    flex-basis: 100%;
    max-width: 100%;
  }
}

.formColumn3 {
  @extend .col-xs-3;
  @include responsive(null, $md1) {
    flex-basis: 100%;
    max-width: 100%;
  }
}

.formColumn4 {
  @extend .col-xs-4;
  @include responsive(null, $md1) {
    flex-basis: 100%;
    max-width: 100%;
  }
}

.formColumn8 {
  @extend .col-xs-8;
  @include responsive(null, $md1) {
    flex-basis: 100%;
    max-width: 100%;
  }
}

.formColumn9 {
  @extend .col-xs-9;
  @include responsive(null, $md1) {
    flex-basis: 100%;
    max-width: 100%;
  }
}

.formColumn10 {
  @extend .col-xs-10;
  @include responsive(null, $md1) {
    flex-basis: 100%;
    max-width: 100%;
  }
}

.formActions {
  padding-top: 24px;
}

.singleCheckboxField {
  @extend .col-xs-12;
  margin-top: 32px;
}

.blockStart {
  margin-top: 24px;
}

.blockStart16 {
  margin-top: 16px;
}

.formColumnBlockStart {
  @extend .col-xs-12;
  margin-top: 24px;
}

.hr {
  margin: 16px 0;
  padding: 0;
  width: 100%;
  height: 1px;
  display: block;
  border: none;
  background-color: $gray200;
}

.fieldWithTwoColumns {
  display: grid;
  @include responsive($md1) {
    grid-template-columns: 1fr 1fr;
    grid-column-gap: 16px;
  }
  @include responsive(null, $md1) {
    grid-row-gap: 16px;
  }
}

.fieldTitle {
  display: flex;
  align-items: center;
  gap: 4px;
  margin-bottom: 16px;
}

.fieldTitleIcon {
  color: $gray400;
  cursor: pointer;

  i {
    display: block;
  }
}
